import { Injectable } from '@angular/core'
import { DadosRelatorio } from './dados-relatorio'

@Injectable()
export class DadosRelatorioService {
    private _dados: DadosRelatorio

    constructor() {}

    limpar() {
        this._dados = undefined
    }

    armazenar(dados: DadosRelatorio) {
        this._dados = dados
    }

    obter() {
        return this._dados
    }

    possui() {
        return !!this._dados
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/relatorio/dados-relatorio.service.ts